<template>
    <div class="founder__content">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="founder_type animate__animated animate__fadeIn"><span>隐上创始人</span></div>
        <div class="wrapper__w">
            <div class="mb70" :style="{'background':'url('+icon_fond01+')', 'background-size': 'cover', 'background-repeat': 'no-repeat'}">
                <div class="founder__good--item founder__good--des fr animate__animated animate__fadeIn" >
                    <div class="bd">胡发录</div>
                    <div class="base">
                        <div class="title"><span>隐上装饰创始人、首席执行官</span></div>
                        <div class="des">胡发录，浙江隐上装饰设计工程有限公司创始人，首席执行官。全面负责公司的战略规划、定位与管理。从零搭建工程设计、施工管理团队包括：核心管家组、管家助理组、匠心施工团队、联合设计团队、后勤组在内的200余人团队。已从事高端装饰行业20余年，一直以“匠人”的精神要求自己，小到一锤一钉，一砖一瓦，每个施工环节都精雕细琢。期望在隐上培育出现代“鲁班”，并将精益求精的“匠人”精神传承下去。</div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="mb70" :style="{'background':'url('+icon_fond02+')', 'background-size': 'cover', 'background-repeat': 'no-repeat'}">
                <div class="founder__good--item founder__good--des fl wow animate__fadeInUp" data-wow-delay=".3s" data-wow-duration="0.8s" >
                    <div class="bd">高中华</div>
                    <div class="base">
                        <div class="title"><span>隐上装饰联合创始人、工程部经理、品控管家</span></div>
                        <div class="des">高中华毕业于浙江建筑安装学校（现浙江省技师学院）建筑装饰施工专业，从事装饰行业21年，是隐上装饰“3+1管家式服务”的核心领军人物。同时，高中华还是2017版浙江省工程建设标准——全装修住宅室内装饰工程质量验收规范的参编者。座右铭：业精于勤而荒于嬉，行成于思而毁于随；初级工程师，持A、C证，监理证等。</div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/add01.png'
    import icon_fond01 from '@/assets/img/fond01.png'
    import icon_fond02 from '@/assets/img/fond02.png'
    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra, icon_fond01, icon_fond02
            }
        },
        components: {
            NavSecond,Footer
        },
        mounted() {
            this.$wow.init()
        },
    }
</script>
<style  lang="scss" scoped>
    .founder__content {
        .founder_type {
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            margin-bottom: 40px;
            span {
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .founder__good--des{
            .title {

                margin: 40px 0;
                margin-top: 20px;
                font-size: 18px;
                font-weight: 400;
                color: #000000;
                span {
                    position: relative;
                    color: #F55E1B;
                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: -10px;
                        width: 32px;
                        height: 4px;
                        background: #F55E1B;
                    }
                }

            }

            .base{
                margin: 0 15%;
            }
            .des{
                font-size: 16px;
                font-weight: 400;
                color: #010101;
                line-height: 24px;
                margin-top: 40px;
                p{
                    margin-top: 20px;
                }
            }
        }
        .founder__good--item{
            height: 420px;
            width: 58%;
            .bd{
                font-size: 28px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin: 0 15%;
                padding-top: 70px;
            }
        }
    }

</style>
